<template>
  <div>
    <div class="card-body">
      <div class="card-header card-header-with-title" v-if="!modalView">
        <legend>Mitigation Questions</legend>
      </div>

      <div class="card-body-overlay" v-if="!client">
        Please complete the "Client Details" section before the Hire details.
      </div>
      <div class="card-body-overlay" v-else-if="!client_vehicle">
        Please complete the "Client Vehicle" section before the Hire details.
      </div>
      <div class="card-body-overlay" v-else-if="generating">
        Generating Vehicle Hire Agreement...
      </div>
      <table
        class="table carpenter table-bordered table-striped"
        v-if="!modalView"
      >
        <thead>
          <tr>
            <th>Question</th>
            <th>Answer</th>
          </tr>
        </thead>
        <tbody v-on:change="changeHandler">
          <tr
            v-bind:key="index"
            v-for="(question, index) in mitigation.questions"
          >
            <td v-text="question.label"></td>
            <td>
              <toggleswitch
                :labels="true"
                :name="question.name"
                v-model="question.answer"
              ></toggleswitch>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="card-header card-header-with-title">
        Drivers
        <button class="btn btn-primary" v-on:click.prevent="openAddDriverModal">
          Add Driver
        </button>
      </div>
      <table class="table carpenter table-bordered table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Has UK Licence?</th>
            <th>Number of Accidents in the Last Three Years?</th>
          </tr>
        </thead>
        <tbody v-if="drivers.length">
          <tr
            v-bind:key="index"
            v-for="(driver, index) in drivers"
            v-on:click.prevent="openEditDriverModal(driver)"
          >
            <td>{{ driver.name }}</td>
            <td>{{ driver.has_uk_licence ? 'Yes' : 'No' }}</td>
            <td>{{ driver.accidents_in_three_years }}</td>
          </tr>
          <tr v-if="!drivers.length">
            <td colspan="3" class="text-center">
              You must add at least one driver. Press the "Add Driver" button to
              get started.
            </td>
          </tr>
        </tbody>
      </table>
      <fieldset v-on:change="changeHandler">
        <legend>
          Delivery Address
          <button
            class="btn btn-primary btn-sm float-right"
            v-on:click.prevent="copyClientAddress"
            v-if="!modalView"
          >
            Copy Client Address
          </button>
        </legend>
        <address-lookup
          :address="address"
          v-on:address="setAddress"
        ></address-lookup>
      </fieldset>
      <fieldset v-on:change="changeHandler">
        <legend>Hire Details</legend>
        <div class="form-group">
          <label for="tax_expiry" class="col-lg-2 control-label"
            >Hire Start Date:</label
          >
          <div class="col-lg-10">
            <datepicker
              format="dd/MM/yyyy"
              v-bind:value="vehicleForm.start_date"
              input-class="form-control"
              v-on:selected="setStartDate"
              v-on:input="changeHandler"
              placeholder="dd/mm/yyyy"
            ></datepicker>
          </div>
        </div>
        <vehicle-lookup
          v-on:vehicle="showVehicle"
          label="Vehicle Registration"
          v-on:vrm="setVrm"
          :registration="vehicleForm.registration"
        ></vehicle-lookup>
        <div v-if="hasVehicle" class="col-md-10 offset-md-2">
          <div class="well">
            <strong>Make: </strong> {{ vehicleData.make.label }} <br />
            <strong>Model: </strong> {{ vehicleData.model }} <br />
            <strong>Engine Capacity:</strong> {{ vehicleData.engine_capacity }}
            <br />
            <strong>Colour:</strong> {{ vehicleData.colour }}
          </div>
        </div>
        <inputbox
          name="daily_rate"
          label="Daily Rate"
          v-model.number="dailyRate"
          type="number"
        >
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox
          name="collision_damage_waiver"
          label="Collision Damage Waiver"
          v-model="collisionDamageWaiver"
        >
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox
          name="collision_damage_waiver_excess"
          label="Collision Damage Waiver Excess"
          v-model="collisionDamageWaiverExcess"
        >
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox name="automatic" label="Automatic" v-model="automatic">
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox name="estate" label="Estate" v-model="estate">
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox name="additional" label="Additional" v-model="additional">
          <div slot="leftAddon">&pound;</div>
        </inputbox>
        <inputbox name="other" label="Other" v-model="other">
          <div slot="leftAddon">&pound;</div>
        </inputbox>
      </fieldset>
    </div>
    <div class="card-footer text-right">
      <div :class="{ 'float-left': !modalView }">
        <div v-if="!hideButton">
          <form-button
            :indicator="generating"
            :disabled="indicator"
            v-on:clicked="generateDocument"
            v-if="!has_document"
          >
            Create Vehicle Hire Agreement
          </form-button>
        </div>
        <button
          class="btn btn-primary btn-raised"
          v-on:click.prevent="viewDocument"
          v-if="has_document"
        >
          View Vehicle Hire Agreement
        </button>
      </div>
      <form-button
        :indicator="indicator"
        :disabled="generating"
        v-on:clicked="submit"
        v-if="!modalView"
        >Save</form-button
      >
    </div>

    <add-driver
      :incident="incident"
      :hire="hire"
      v-if="modals.add"
      v-on:close="closeAddDriverModal"
      :types="types"
      v-on:added="driverWasAdded"
      :client="client"
    ></add-driver>

    <edit-driver
      :incident="incident"
      :hire="hire"
      v-if="modals.edit"
      v-on:close="closeEditDriverModal"
      :types="types"
      v-on:updated="driverWasUpdated"
      :client="client"
      :driver="editingDriver"
      v-on:deleted="removeDriver"
    ></edit-driver>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
import AddDriver from './Children/AddDriver.vue';
import EditDriver from './Children/EditDriver.vue';
import VehicleLookup from './../../../Generic/VehicleLookup.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    modalView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddDriver,
    EditDriver,
    VehicleLookup
  },

  computed: {
    address() {
      return {
        address_line_one: this.details.address_line_one,
        address_line_two: this.details.address_line_two,
        city: this.details.city,
        postcode: this.details.postcode
      };
    },

    dailyRate: {
      get() {
        return this.penceToPounds(this.rates.daily);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.daily = parseInt(this.poundsToPence(newValue));
          return;
        }

        this.rates.daily = 0;
      }, 500)
    },

    collisionDamageWaiver: {
      get() {
        return this.penceToPounds(this.rates.collision_damage_waiver);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.collision_damage_waiver = parseInt(
            this.poundsToPence(newValue)
          );
          return;
        }

        this.rates.collision_damage_waiver = 0;
      }, 500)
    },

    collisionDamageWaiverExcess: {
      get() {
        return this.penceToPounds(this.rates.collision_damage_waiver_excess);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.collision_damage_waiver_excess = parseInt(
            this.poundsToPence(newValue)
          );
          return;
        }

        this.rates.collision_damage_waiver_excess = 0;
      }, 500)
    },

    automatic: {
      get() {
        return this.penceToPounds(this.rates.automatic);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.automatic = parseInt(this.poundsToPence(newValue));
          return;
        }

        this.rates.automatic = 0;
      }, 500)
    },

    estate: {
      get() {
        return this.penceToPounds(this.rates.estate);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.estate = parseInt(this.poundsToPence(newValue));
          return;
        }

        this.rates.estate = 0;
      }, 500)
    },

    additional: {
      get() {
        return this.penceToPounds(this.rates.additional);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.additional = parseInt(this.poundsToPence(newValue));
          return;
        }

        this.rates.additional = 0;
      }, 500)
    },

    other: {
      get() {
        return this.penceToPounds(this.rates.other);
      },
      set: debounce(function(newValue) {
        if (newValue > 0) {
          this.rates.other = parseInt(this.poundsToPence(newValue));
          return;
        }

        this.rates.other = 0;
      }, 500)
    },

    hasVehicle() {
      return Object.keys(this.vehicleData).length > 0;
    }
  },

  data() {
    return {
      indicator: false,
      generating: false,
      drivers: [],
      modals: {
        add: false,
        edit: false
      },
      types: [],
      hire: null,
      client: null,
      client_vehicle: null,
      mitigation: new window.Form({
        questions: []
      }),
      vehicle: null,
      vehicleData: {},
      editingDriver: null,
      details: new window.Form({
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null
      }),
      vehicleForm: new window.Form({
        start_date: null,
        registration: null
      }),
      rates: new window.Form({
        daily: 0,
        collision_damage_waiver: 0,
        collision_damage_waiver_excess: 0,
        automatic: 0,
        estate: 0,
        additional: 0,
        other: 0
      }),
      has_document: false,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  methods: {
    setVrm(vrm) {
      this.vehicleForm.registration = vrm;
    },

    showVehicle(vehicle) {
      this.vehicleData = vehicle;
      this.vehicleForm.registration = this.vehicleData.registration;
    },

    generateDocument() {
      this.submit().then(() => {
        this.complete();
      });
    },

    complete() {
      this.generating = true;

      let vha = new Promise((resolve, reject) => {
        window.Ajax.post('/hires/' + this.hire + '/complete')
          .then(response => {
            resolve();
          })
          .catch(error => {
            reject();
          });
      });

      let storage = new Promise((resolve, reject) => {
        window.Ajax.post(
          `/incidents/${this.incident}/client/${this.client.identifier}/vehicle/${this.vehicle}/recovery/document`
        )
          .then(response => {
            resolve();
          })
          .catch(error => {
            reject();
          });
      });

      Promise.all([vha, storage])
        .then(() => {
          this.generating = false;
          this.route(`/first-notice-of-loss/${this.incident}/complete`);
        })
        .catch(() => {
          this.generating = false;
          window.toastify.error(
            'Error',
            "Sorry, we couldn't generate the document. Please try again"
          );
        });
    },

    setAddress(address) {
      this.details.address_line_one = address.address_line_one;
      this.details.address_line_two = address.address_line_two;
      this.details.city = address.city;
      this.details.postcode = address.postcode;
    },

    copyClientAddress() {
      this.details.address_line_one = this.client.address_line_one;
      this.details.address_line_two = this.client.address_line_two;
      this.details.city = this.client.city;
      this.details.postcode = this.client.postcode;
    },

    openEditDriverModal(driver) {
      this.editingDriver = driver;
      this.modals.edit = true;
    },

    findIndex(identifier) {
      return this.drivers.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeDriver(driver) {
      this.closeEditDriverModal();

      let index = this.findIndex(driver.identifier);

      this.drivers.splice(index, 1);

      window.toastify.success(
        'Driver Deleted',
        'The driver was deleted successfully!'
      );
    },

    driverWasUpdated(driver) {
      this.closeEditDriverModal();

      let index = this.findIndex(driver.identifier);

      this.$set(this.drivers, index, driver);

      window.toastify.success(
        'Success!',
        'The driver was updated successfully!'
      );
    },

    closeEditDriverModal() {
      this.modals.edit = false;
      this.editingDriver = null;
    },

    driverWasAdded(driver) {
      this.drivers.push(driver);
      this.closeAddDriverModal();
      window.toastify.success('Success!', 'The driver was added successfully!');
    },

    closeAddDriverModal() {
      this.modals.add = false;
    },

    openAddDriverModal() {
      this.modals.add = true;
    },

    isQuestionChecked(question) {
      if (this.mitigation.hasData(question.identifier)) {
        return this.mitigation[question.identifier];
      }

      return false;
    },

    mount() {
      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data;

          window.Ajax.get(
            '/incidents/' +
              this.incident +
              '/client/' +
              this.client.identifier +
              '/vehicle'
          )
            .then(response => {
              this.client_vehicle = response.data.identifier;

              window.Ajax.get(
                '/incidents/' +
                  this.incident +
                  '/client/' +
                  this.client.identifier +
                  '/vehicle/mitigation-questions'
              )
                .then(response => {
                  this.mitigation.questions = response.data;

                  window.Ajax.get(
                    '/incidents/' +
                      this.incident +
                      '/client/' +
                      this.client.identifier +
                      '/mitigation-questions'
                  )
                    .then(response => {
                      response.data.forEach(question => {
                        let record = this.mitigation.questions.find(record => {
                          return record.identifier === question.identifier;
                        });

                        record.answer = question.answer;
                      });

                      window.Ajax.post('/incidents/' + this.incident + '/hire')
                        .then(response => {
                          this.hire = response.data.credit_hire.identifier;
                          this.has_document =
                            response.data.credit_hire.has_vehicle_hire_agreement;

                          if (response.data.credit_hire.vehicle) {
                            let vehicle = response.data.credit_hire.vehicle;

                            this.vehicle = vehicle.identifier;
                            this.vehicleForm.registration =
                              vehicle.registration;
                            if (vehicle.start_date) {
                              this.vehicleForm.start_date = window.DateManager.format(
                                vehicle.start_date
                              );
                            }

                            if (vehicle.rates) {
                              this.rates.daily = vehicle.rates.daily;
                              this.rates.collision_damage_waiver =
                                vehicle.rates.collision_damage_waiver;
                              this.rates.collision_damage_waiver_excess =
                                vehicle.rates.collision_damage_waiver_excess;
                              this.rates.automatic = vehicle.rates.automatic;
                              this.rates.estate = vehicle.rates.estate;
                              this.rates.additional = vehicle.rates.additional;
                              this.rates.other = vehicle.rates.other;
                            }
                          }

                          if (response.data.credit_hire.details) {
                            let details = response.data.credit_hire.details;

                            this.details.address_line_one =
                              details.address_line_one;
                            this.details.address_line_two =
                              details.address_line_two;
                            this.details.city = details.city;
                            this.details.postcode = details.postcode;
                          }

                          window.Ajax.get('/hires/' + this.hire + '/drivers')
                            .then(response => {
                              this.drivers = response.data;
                            })
                            .catch(error => {});
                        })
                        .catch(error => {});

                      window.Ajax.get('/driver-types')
                        .then(response => {
                          this.types = response.data;
                        })
                        .catch(error => {});
                    })
                    .catch(error => {});
                })
                .catch(error => {});
            })
            .catch(error => {});
        })
        .catch(error => {});
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      return new Promise((resolve, reject) => {
        this.indicator = true;
        this.mitigation
          .post(
            '/incidents/' +
              this.incident +
              '/client/' +
              this.client.identifier +
              '/mitigation-questions'
          )
          .then(response => {
            this.details
              .post('/hires/' + this.hire + '/details')
              .then(response => {
                this.indicator = false;
                let hasVehicle = this.vehicle;
                let url = hasVehicle
                  ? '/hires/' + this.hire + '/vehicles/' + this.vehicle
                  : '/hires/' + this.hire + '/vehicles';
                this.processVehicle(hasVehicle ? 'put' : 'post', url);
                // reset monitoring of form changes
                this.data_entered = false;
                this.$emit('unsaved-data', this.data_entered);
                resolve();
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error saving the data'
                );
                reject();
              });
          })
          .catch(error => {
            this.indicator = false;
            window.toastify.error(
              'Error',
              'Sorry, there was an error saving the data'
            );
            reject();
          });
      });
    },

    setStartDate(date) {
      this.vehicleForm.start_date = date;
    },

    processVehicle(method, url) {
      this.vehicleForm[method](url)
        .then(response => {
          this.vehicle = response.identifier;

          this.processRates();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the data'
          );
        });
    },

    processRates() {
      this.rates
        .post('/hires/' + this.hire + '/vehicles/' + this.vehicle + '/rates')
        .then(response => {
          window.toastify.success('Saved', "We've saved those details for you");
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the data'
          );
        });
    },

    viewDocument() {
      this.$router.push('/first-notice-of-loss/' + this.incident + '/complete');
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
